module.exports = __webpack_public_path__ + "static/epitome-venti2-banner-10286d161f4241def268f80c830a8bb1.png";